import { Logo } from "@components/atoms/Logo"
import { Menu } from "@components/atoms/Menu"
import { Link } from "eddev/routing"
import { UserMenu } from "./UserMenu"

export function Header() {
  return (
    <div className="sticky top-0 z-50 left-0 right-0 border-b border-b-black bg-white h-headerHeight flex items-center">
      <div className="grid-auto items-center py-2">
        <div className="col-span-3 flex">
          <Link className="inline-block" href="/">
            <Logo />
          </Link>
        </div>

        <div className="col-span-9 flex">
          <div className="hidden md:flex items-center link-active:el-a:underline">
            <Menu location="Main" />
          </div>
          <div className="flex-1" />
          <UserMenu />
        </div>
      </div>
    </div>
  )
}
